import { Injectable, inject } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { ApiService } from '../api/api.service';

export interface PublicFaqItem {
  id: string;
  question: string;
  answer: string;
  sortOrder?: number;
  category?: string | null;
}

export interface PublicFaqGroup {
  id: string;
  name: string;
  icon: string;
  color: string;
  bgColor: string;
  sortOrder: number;
}

@Injectable({ providedIn: 'root' })
export class FaqsService {
    private api = inject(ApiService);

    getPublicFaqs(options: { page?: number; perPage?: number } = {}): Observable<PublicFaqItem[]> {
        const page = options.page ?? 1;
        const perPage = options.perPage ?? 200;
        const params = new HttpParams().set('page', String(page)).set('per_page', String(perPage));
        return this.api.get<any>('/Public/faqs', params).pipe(
            map((response) => {
                const rows = Array.isArray(response?.data) ? response.data : Array.isArray(response) ? response : [];
return rows.map((row: any) => ({
          id: String(row?.id || row?.ROWID || ''),
          question: String(row?.question || row?.QUESTION || '').trim(),
          answer: String(row?.answer || row?.ANSWER || '').trim(),
          sortOrder: Number(row?.sort_order ?? row?.SORT_ORDER ?? row?.sortOrder ?? 0) || 0,
          category: row?.category || row?.CATEGORY || null
        }));
            })
        );
    }

    getPublicFaqGroups(): Observable<PublicFaqGroup[]> {
        return this.api.get<any>('/Public/faqs/groups').pipe(
            map((response) => {
                const rows = Array.isArray(response?.data) ? response.data : [];
                return rows.map((row: any) => ({
                    id: String(row?.id || ''),
                    name: String(row?.name || '').trim(),
                    icon: String(row?.icon || 'help-circle').trim(),
                    color: String(row?.color || '#64748b').trim(),
                    bgColor: String(row?.bgColor || row?.bg_color || '#f8fafc').trim(),
                    sortOrder: Number(row?.sortOrder ?? row?.sort_order ?? 0) || 0
                }));
            })
        );
    }
}

